<section class="container footer-Container-Section mb-0">
  <section class="row">
    <section class=" col-12 col-sm-3 col-md-3 pt-3 influenza-Contact-Section p-4">
      <!-- <app-flu-dashboard-banner [bannerComponent]="compName"></app-flu-dashboard-banner> -->
    </section>
    <section class="col d-lg-flex d-xl-flex flex-wrap p-0">
      @for (season of totalData; track season) {
        <section class="col-12 col-lg-6 col-xl-6 active-season-Section p-4">
          <section>
            <section class="row">
              <section class="col-12 col-xs-12 col-md-8 col-xl-9 col-lg-9">
                <section class="season-header">
                  {{season.code}} {{'selectVaccines.season'|cxTranslate}}
                </section>
              </section>
            </section>
            <section class="row mb-4">
              @if (getOnsnStatusFlag(season.code)) {
                <section class="col-12 col-xs-12 col-md-10 col-xl-10 col-lg-10 dss-avlble-immdt-shpmnt"
                  >
                  Doses available for immediate shipment
                </section>
              }
            </section>
            <!--products-->
            @for (product of season.products; track product; let i = $index) {
              <section class="row row-Gap mr-0 ml-0"
                id="{{product.code}}">
                <section class="productImageContainer">
                  <a (click)="productDetails(product)">
                    @if (product?.images) {
                      <img src="{{baseUrl}}{{product?.images[2]?.url}}" class="vaccine-Image"
                        alt="prodImg" />
                    }
                    @if (!product?.images) {
                      <img [src]="'/icons/'+baseSiteId+'/sanofi_missing_product.jpg'"
                        class="vaccine-Image" alt="defImg" />
                    }
                  </a>
                </section>
                <section class="col-10 col-sm-10 col-md-8 col-lg-10 col-xl-10 prod-Desc-Div p-0">
                  <section class="container p-0">
                    <section class="">
                      <section class="col-md-12 col-lg-12 col-xl-12 p-0">
                        <a (click)="productDetails(product)" title="{{product.variantProductDescription}}"
                        class="vaccine-Name mb-2" [innerHTML]="product.variantProductDescription"></a>
                      </section>
                      <section class="col-md-12 col-lg-12 col-xl-12 prod-No p-0">
                        @if (product?.ndcCode) {
                          <p class="ndcCode">
                          {{product.ndcCode}}</p>
                        }
                      </section>
                      <section class="col-md-12 col-lg-12 col-xl-12 prod-No p-0">
                        <span class="prodct-No">{{product.code}}</span>
                      </section>
                      @if (product?.innerText && product?.innerText !== '') {
                        <p class="inner-text">
                          <span [innerHtml]="product?.innerText"></span>
                        </p>
                      }
                      <div class="statusForProd">
                        @if (product?.soldOut) {
                          <span class="text-right alertRes">
                            {{product?.soldOutMessageCreate ? product?.soldOutMessageCreate : 'Sold out'}}
                          </span>
                        }
                        @if (product?.orderable && product?.waitlist && !product?.soldOut) {
                          <span
                            class="text-right alertRes">
                            Waitlist
                          </span>
                        }
                        @if (product?.orderable && product?.shipNow=='ON' && !product?.waitlist && !product?.soldOut) {
                          <span
                            class="text-right orderAvailable">
                            Available to order now
                          </span>
                        }
                      </div>
                    </section>
                  </section>
                </section>
                <!-- ============================order acceptance=========================================== -->
              </section>
            }
          </section>
        </section>
      }
    </section>
  </section>
</section>
